import React from "react";
import SectionTitle from "../components/SectionTitle";
import SkillCloud from "../components/SkillCloud";
import InfoData from "../InfoData";
import SectionWrapper from "../components/SectionWrapper";
import Card from "../components/Card";
import { useInView } from "react-intersection-observer";

const skillsTag = InfoData.skills;
const skillsRate = InfoData.skillRate;

const Skills = () => {
    const skillRateRun = (() => {
        let currentValue = 0;
        let interval = setInterval(() => {
            if (currentValue >= 100) {
                clearInterval(interval);
            }

            document.querySelectorAll('.rate-bar').forEach(elem => {
                const rate = elem.getAttribute('data-rate');
                const rateValue = rate * 100;
                if (rateValue >= currentValue) {
                    elem.style.width = currentValue + '%';
                }
            });
            currentValue++;
        }, 10);
    });

    const SkillRateItem = ({ name, value }) => {
        return (
            <div className="py-4">
                <div>{name}</div>
                <div className="h-1.5 relative truncate">
                    <span className="rate-bar h-full block bg-white" data-rate={value}></span>
                </div>
            </div>
        );
    }
    
    const SkillRateGrid = ({ gridInfo, isOdd }) => {
        return (
            <Card classes={`p-4 ${isOdd ? "border-primary" : "border-secondary"}`}>
                <div className="text-xl font-bold text-center">{gridInfo.category}</div>
                <div className={`border-2 border-solid width-[30%] mx-auto my-4 ${isOdd ? 'border-primary' : 'border-secondary'}`}></div>
                {
                    gridInfo.skills.map((skill, index) => (
                        <SkillRateItem key={index} {...skill}/>
                    ))
                }
            </Card>
        );
    }

    const setInView = (inView) => {
        if (inView) {
            skillRateRun();
        }
    }
    
    const SkillRateContainer = ({ skillsRate }) => {
        const {ref} = useInView({
            onChange: setInView,
        });
    
        return (
            <div ref={ref} className="grid grid-cols-1 md:grid-cols-3 gap-8">
                {
                    skillsRate.map((gridInfo, index) => (
                        <SkillRateGrid key={index} gridInfo={gridInfo} isOdd={index % 2 === 0}/>
                    ))
                }
            </div>
        );
    }

    return (
        <SectionWrapper id="skills">
            <SectionTitle title="Skills"/>
            <SkillCloud skills={skillsTag} />
            <SkillRateContainer skillsRate={skillsRate}/>
        </SectionWrapper>
    );
}

export default Skills;